export default "__VITE_ASSET__D4nZ4jJb__"